function bmFloatingHeader() {
	var top = jQuery('.bm-Header__Inner').outerHeight();

	jQuery(
		'.bm-Option--Header--Padded-First-Section section:first-of-type, .bm-Option--Header--Floating .bm-Section--Padded-First-Section'
	).css({ 'padding-top': top + 'px' });

	jQuery(
		'.bm-Option--Header--Padded-First-Section section:first-of-type'
	).css({ 'padding-top': top + 'px' });

	// Class to apply padding to sections in templates where page-level options arent displayed by default; archive.php, index.php etc.
	jQuery(
		'.bm-Option--Header--Floating .bm-Option--Header--Floating__Padding-Top'
	).css({ 'padding-top': top + 'px' });
}

jQuery(window).on('resize', function (e) {
	bmFloatingHeader();
});

// This delays the function from running until 100 milliseconds after the page has loaded which resolves the bug of using window load event in Firefox
setTimeout(function () {
	bmFloatingHeader();
}, 200);

// Use jQuery to run the bmFloatingHeader function on document ready
/**jQuery(document).ready(function() {
	bmFloatingHeader();
});

// Use jQuery to run the bmFloatingHeader function on page resize
jQuery(window).resize(function() {
	bmFloatingHeader();
}
);
**/
